import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GenericBulkUpsertFeatureState, ResetState } from './shared/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'bulk-upsert-container',
  template: `
    <nav class="u-m-b-16">
      <ul class="breadcrumbs">
        <li>Bulk Upsert</li>
      </ul>
    </nav>
    <header class="u-m-b-40">
      <div class="row">
        <div class="columns">
          <h1 class="typography--display1">Bulk Upsert</h1>
        </div>
      </div>
    </header>
    <div class="row u-m-b-20">
      <div class="columns small-12 medium-6 large-4">
        <label for="bulkUpsertType">Select Bulk Upsert Type</label>
        <select id="bulkUpsertType" (change)="onTypeChange($event.target.value)" [value]="currentRoute">
          <option value="zipcode">Zip Code</option>
          <option value="rate-package">Rate Package</option>
          <option value="rate-agreement">Rate Agreement</option>
          <option value="preferences">Preferences (Coming Soon)</option>
          <option value="instrument-credit-check">Instrument Credit Check (Coming Soon)</option>
        </select>
      </div>
    </div>
    <div class="row u-m-b-20" *ngIf="currentRoute === 'rate-package'">
      <div class="columns">
        <div class="callout callout--warning">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          <strong>Important:</strong> Uploading a Rate Package file will <strong>delete</strong> any existing packages
          assigned to the same Rate Agreements that are not present in the uploaded file. Only packages belonging to
          the Rate Agreements being processed are affected.
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  `
})
export class BulkUpsertContainerComponent {
  constructor(protected store: Store<GenericBulkUpsertFeatureState>, private router: Router) {}

  get currentRoute(): string {
    const url = this.router.url;
    if (url.includes('zipcode')) return 'zipcode';
    if (url.includes('preferences')) return 'preferences';
    if (url.includes('instrument-credit-check')) return 'instrument-credit-check';
    if (url.includes('rate-package')) return 'rate-package';
    if (url.includes('rate-agreement')) return 'rate-agreement';
    return 'zipcode';
  }

  onTypeChange(route: string): void {
    this.store.dispatch(new ResetState());
    this.router.navigate(['/bulk-upsert', route]);
  }
}
